import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';

import { AngularFireModule } from 'angularfire2';

import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import {LoginService} from './login/login.service';
import {UpdateNotificationService} from './layout/notifications-page/update-notification.service';
import { environment } from 'environments/environment';
import { NotificationsService } from './shared/components/Notifications/notifications-service';
 
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import {LoaderComponent }from './shared/components/loader/loader.component';
import { CustomerLoginService } from './customer/customerlogin/customerlogin.service';

export const firebaseConfig = environment.firebaseConfig;


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    // for development
    // return new TranslateHttpLoader(http, '/start-angular/SB-Admin-BS4-Angular-4/master/dist/assets/i18n/', '.json');
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}


@NgModule({
    declarations: [
        AppComponent, SpinnerComponent, LoaderComponent 
       
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
       AngularFireModule.initializeApp(firebaseConfig),
      
         
        AngularFireDatabaseModule,
        AngularFireAuthModule,

        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [Http]
            }
        })
    ],
    providers: [AuthGuard, AngularFireAuthModule, AngularFireDatabaseModule, LoginService , CustomerLoginService, UpdateNotificationService, NotificationsService],
    exports: [ SpinnerComponent ],
   
    bootstrap: [AppComponent]
})

export class AppModule {

}




// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/app.module.ts